var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 356,
    viewBox: "0 0 277 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_1495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.414 0H65.487C29.716 0 0 31.595 0 67.365V216.293C0 251.994 29.716 281.57 65.486 281.57H97.637L114.27 310.59L139.949 355.547L165.629 310.799L182.262 281.57H214.413C250.113 281.57 276.142 251.994 276.142 216.293V67.365C276.142 31.595 250.114 0 214.414 0Z",
    fill: "#131312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.639 210.6C156.639 210.6 153.506 209.533 151.239 207.4C148.972 205.133 147.839 201.933 147.839 197.8V182.2H98.4391C94.3058 182.2 90.9724 181.333 88.4391 179.6C86.0391 177.867 84.8391 175.133 84.8391 171.4C84.8391 169.267 85.3724 166.933 86.4391 164.4C87.6391 161.867 89.7058 158.533 92.6391 154.4L147.439 74.9999C149.306 72.1999 151.372 70.0666 153.639 68.5999C155.906 67.1332 158.506 66.3999 161.439 66.3999C164.906 66.3999 167.772 67.4666 170.039 69.5999C172.306 71.5999 173.439 74.7999 173.439 79.1999V161H183.239C187.106 161 189.972 161.933 191.839 163.8C193.839 165.533 194.839 168.133 194.839 171.6C194.839 175.067 193.839 177.733 191.839 179.6C189.972 181.333 187.106 182.2 183.239 182.2H173.439V197.8C173.439 201.933 172.306 205.133 170.039 207.4C167.772 209.533 164.639 210.6 160.639 210.6ZM147.839 161V98.5999H153.639L106.439 167.8V161H147.839Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_1495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276.196,
    height: 355.547,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop4);
export default __webpack_public_path__ + "static/media/stop4.6873ed02c9b630408769bc1a010279e3.svg";
export { ForwardRef as ReactComponent };